enum User {
  SET_USER_INITIALIZE = 'SET_USER_INITIALIZE',
  SET_USER_INITIALIZE_APPLICATION = 'SET_USER_INITIALIZE_APPLICATION',
  SET_USER_LOGIN_STATE = 'SET_USER_LOGIN_STATE',
  SET_USER_AUTH_STATE = 'SET_USER_AUTH_STATE',
  SET_USER_OAUTH_PROCESS_STATE = 'SET_USER_OAUTH_PROCESS_STATE',
  SET_USER_TOKEN_INFO = 'SET_USER_TOKEN_INFO',
  SET_USER_SIGN_IN_OAUTH_URL = 'SET_USER_SIGN_IN_OAUTH_URL',
  SET_USER_SIGN_OUT_OAUTH_URL = 'SET_USER_SIGN_OUT_OAUTH_URL',
  SET_USER_PERMISSION_LIST = 'SET_USER_PERMISSION_LIST',
  SET_USER_ROLE_LIST = 'SET_USER_ROLE_LIST'
}

export default User;
